import { PERMISSIONS } from "consts";

const routePermissions = {
    "/users": [PERMISSIONS.GLOBAL_ADMINISTRATION, PERMISSIONS.GLOBAL_USER_MANAGEMENT],
    "/groups": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_REPORTS,
        PERMISSIONS.GLOBAL_USER_MANAGEMENT,
        PERMISSIONS.REPORTS,
        PERMISSIONS.USER_MANAGEMENT,
    ],
    "/access-requests": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_USER_MANAGEMENT,
        PERMISSIONS.USER_MANAGEMENT,
    ],
    "/overtime": [PERMISSIONS.ADMINISTRATION, PERMISSIONS.GLOBAL_ADMINISTRATION],
    "/projects": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_USER_MANAGEMENT,
        PERMISSIONS.USER_MANAGEMENT,
    ],
    "/billable-projects": [
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_REPORTS,
    ],
    "/reports/advanced": [PERMISSIONS.GLOBAL_ADMINISTRATION, PERMISSIONS.GLOBAL_REPORTS],
    "/reports/presence": [PERMISSIONS.GLOBAL_ADMINISTRATION, PERMISSIONS.GLOBAL_REPORTS],
    "/reports/projects": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_REPORTS,
        PERMISSIONS.REPORTS,
    ],
    "/reports/project-plus": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_REPORTS,
        PERMISSIONS.REPORTS,
    ],
    "/reports/users": [PERMISSIONS.GLOBAL_ADMINISTRATION, PERMISSIONS.GLOBAL_REPORTS],
    "/reports/customer": [
        PERMISSIONS.ADMINISTRATION,
        PERMISSIONS.GLOBAL_ADMINISTRATION,
        PERMISSIONS.GLOBAL_REPORTS,
        PERMISSIONS.REPORTS,
    ],
    "/exports/enova": [PERMISSIONS.GLOBAL_ADMINISTRATION, PERMISSIONS.GLOBAL_REPORTS],
    "/lock": [PERMISSIONS.LOCKING],
    MailModule: [PERMISSIONS.ADMINISTRATION, PERMISSIONS.GLOBAL_ADMINISTRATION],
    "/mail": [PERMISSIONS.GLOBAL_ADMINISTRATION],
    "/mail/templates": [PERMISSIONS.ADMINISTRATION, PERMISSIONS.GLOBAL_ADMINISTRATION],
    "/locations": [PERMISSIONS.GLOBAL_ADMINISTRATION],
    "/templatesManager": [PERMISSIONS.GLOBAL_ADMINISTRATION],
};

export function assertUserPermissions(route, userPermissions = []) {
    return routePermissions[route].some((requiredPermission) => userPermissions[requiredPermission]);
}
